import { render } from "./ResourceListItem.vue?vue&type=template&id=ac10a8e6&scoped=true"
import script from "./ResourceListItem.vue?vue&type=script&lang=js"
export * from "./ResourceListItem.vue?vue&type=script&lang=js"

import "./ResourceListItem.vue?vue&type=style&index=0&id=ac10a8e6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac10a8e6"]])

export default __exports__